import SectionHeading from "./SectionHeading";

const steps = [
  {
    step: "01",
    title: "Create your account",
    text: "Sign up in seconds with email and password — no clutter, no upsells.",
  },
  {
    step: "02",
    title: "Add what you own & owe",
    text: "Log assets and liabilities with categories that match how you think about money.",
  },
  {
    step: "03",
    title: "Watch the picture emerge",
    text: "Net worth, allocation, and history update as you go — snapshots keep the trend honest.",
  },
];

/**
 * Three onboarding steps led by large faint tabular numerals — the
 * numbers do the visual work, no icons or cards needed.
 */
export default function LandingHowItWorks() {
  return (
    <section
      id="how"
      className="scroll-mt-24 border-t border-vaulzo-hairline py-16 sm:py-24"
    >
      <div className="mx-auto max-w-[800px] px-6">
        <SectionHeading
          eyebrow="How it works"
          title="Three steps to a living picture"
          subtitle="From zero to a living snapshot of your wealth."
        />

        <ol className="mt-14 grid gap-10 sm:grid-cols-3 sm:gap-8">
          {steps.map(({ step, title, text }) => (
            <li key={step}>
              <div className="num text-[40px] font-bold leading-none tracking-[-0.03em] text-vaulzo-bar">
                {step}
              </div>
              <h3 className="mt-4 text-[16px] font-semibold text-vaulzo-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-vaulzo-faint">{text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
